import { IvrFlowType } from '../types'
import { NOT_LOGGED_IN } from '../errors'

type SuccessFallbackType = Array<unknown> | Object
type ErrorFallbackType = { message?: string; [k: string]: unknown }

export default function kycPostGetter<
  SuccessResponse = SuccessFallbackType,
  PostBody extends Record<
    string | number,
    string | number | object | boolean
  > = Record<string | number, string | number | object | boolean>,
  ErrorResponse extends ErrorFallbackType = ErrorFallbackType,
>(urlGetter: (flowType: IvrFlowType) => string) {
  return async function kycPost({
    body,
    flowType = 'US_STOCKS_SBM',
    authToken,
  }: {
    body?: PostBody
    flowType: IvrFlowType
    authToken: string
  }) {
    const response = await fetch(urlGetter(flowType), {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
      method: 'POST',
    })

    let json: ErrorResponse | SuccessResponse

    // TODO: extract this logic out to reuse, defering it because it's hard to extract things out in typescript quickly
    if (response.ok) {
      json = await response.json()
    } else if (response.status === 401) {
      throw new Error(NOT_LOGGED_IN)
    } else if (response.status === 500) {
      throw new Error('Something went wrong')
    } else {
      try {
        json = (await response.json()) as ErrorResponse // TODO: see how to handle this better without asserting
      } catch {
        throw new Error('Something went wrong while submitting data')
      }

      if (json.message) {
        throw new Error(json.message)
      } else {
        throw new Error('Something went wrong')
      }
    }

    return json
  }
}
